/* ============================================
   BASE1 MEGA MENU — Interactions
   ============================================ */

(function () {
  'use strict';

  const SELECTORS = {
    nav: '.mega-nav',
    hamburger: '.mega-nav__hamburger',
    drawer: '.mega-nav__drawer',
    drawerHeading: '.mega-nav__drawer-heading',
    drawerLinks: '.mega-nav__drawer-links',
    menuItem: '.mega-nav__item',
    panel: '.mega-nav__panel',
  };

  let closeTimeout = null;

  function init() {
    setupDesktopHover();
    setupMobileDrawer();
    setupKeyboard();
  }

  /* ---- Desktop: intent-based hover ---- */
  function setupDesktopHover() {
    const items = document.querySelectorAll(SELECTORS.menuItem);

    items.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        clearTimeout(closeTimeout);
        items.forEach((other) => {
          if (other !== item) other.classList.remove('mega-nav__item--active');
        });
        item.classList.add('mega-nav__item--active');
      });

      item.addEventListener('mouseleave', () => {
        closeTimeout = setTimeout(() => {
          item.classList.remove('mega-nav__item--active');
        }, 120);
      });

      const panel = item.querySelector(SELECTORS.panel);
      if (panel) {
        panel.addEventListener('mouseenter', () => {
          clearTimeout(closeTimeout);
        });
        panel.addEventListener('mouseleave', () => {
          closeTimeout = setTimeout(() => {
            item.classList.remove('mega-nav__item--active');
          }, 120);
        });
      }
    });
  }

  /* ---- Mobile: accordion drawer ---- */
  function setupMobileDrawer() {
    const hamburger = document.querySelector(SELECTORS.hamburger);
    const drawer = document.querySelector(SELECTORS.drawer);
    if (!hamburger || !drawer) return;

    hamburger.addEventListener('click', () => {
      const isOpen = drawer.classList.contains('mega-nav__drawer--open');
      hamburger.classList.toggle('mega-nav__hamburger--open', !isOpen);
      drawer.classList.toggle('mega-nav__drawer--open', !isOpen);
      hamburger.setAttribute('aria-expanded', String(!isOpen));
      document.body.style.overflow = isOpen ? '' : 'hidden';
    });

    const headings = drawer.querySelectorAll(SELECTORS.drawerHeading);
    headings.forEach((heading) => {
      heading.addEventListener('click', () => {
        const links = heading.nextElementSibling;
        if (!links) return;
        const isOpen = links.classList.contains('mega-nav__drawer-links--open');

        // Close others
        drawer.querySelectorAll(SELECTORS.drawerLinks).forEach((l) => {
          l.classList.remove('mega-nav__drawer-links--open');
        });
        drawer.querySelectorAll(SELECTORS.drawerHeading).forEach((h) => {
          h.classList.remove('mega-nav__drawer-heading--open');
        });

        if (!isOpen) {
          links.classList.add('mega-nav__drawer-links--open');
          heading.classList.add('mega-nav__drawer-heading--open');
        }
      });
    });
  }

  /* ---- Keyboard: Escape closes everything ---- */
  function setupKeyboard() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        // Close desktop panels
        document.querySelectorAll(SELECTORS.menuItem).forEach((item) => {
          item.classList.remove('mega-nav__item--active');
        });
        // Close mobile drawer
        const hamburger = document.querySelector(SELECTORS.hamburger);
        const drawer = document.querySelector(SELECTORS.drawer);
        if (hamburger && drawer) {
          hamburger.classList.remove('mega-nav__hamburger--open');
          drawer.classList.remove('mega-nav__drawer--open');
          hamburger.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
        }
      }
    });
  }

  /* ---- Boot ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
